import PageComponent from '@gameday/common/components/form/Pages/Payment'
import { useEffect } from 'react'
import styled from 'styled-components'

import history from '../../../../_history'

const StyledPayments = styled.div`
  --custom-primary-color: ${props => props.formSettings.textLinkColour};
`

const PaymentComponent = ({ validateSessions, formSettings, setPaymentError = () => {}, ...rest }) => {
  useEffect(() => {
    setPaymentError({
      title: null,
    })
  }, [])
  return (
    <StyledPayments formSettings={formSettings}>
      <PageComponent
        formSettings={formSettings}
        validateSessions={validateSessions}
        history={history}
        buttonColour={formSettings.buttonColour}
        buttonTextColour={formSettings.buttonTextColour}
        {...rest}
      />
    </StyledPayments>
  )
}

export default PaymentComponent
